<template>
    <div>
        <vue-headful :title="$t('cabinet-specialist-see')" />
        <!-- ШАГ 1 карточки с типами специаолистов -->
        <div v-if="step === 1">
            <div :class="wMobile ? 'flex-col' : ''" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <vs-card
                    style="cursor: pointer"
                    class="flex flex-col justify-between mb-0"
                    v-for="item in list"
                    :key="item.uid"
                >
                    <template #media>
                        <img
                            @click="selectSpec(item)"
                            style="object-fit: cover"
                            :src="item.image.image"
                            alt=""
                        />
                    </template>
                    <h2
                        @click="selectSpec(item)"
                        style="color: #545da7; text-align: center"
                    >
                        {{ item.name }}
                    </h2>
                </vs-card>
            </div>
        </div>
        <!-- 2 ШАГ СПЕЦИАЛИСТЫ -->
        <div v-else>
            <div class="flex items-center">
                <vs-button icon="reply" radius @click="step = 1"></vs-button>
                <!-- Тип специалиста -->
                <h3 class="ml-2" style="color: #545da7">
                    {{ selectItem.name }}
                </h3>
            </div>

            <template v-if="selectItem && !selectItem.specialistcv.length">
                <vs-alert class="mt-4" active="true">
                    {{ $t("no_data_text") }}
                </vs-alert>
            </template>

            <div :class="wMobile ? 'flex-col' : ''" class="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                <vs-card
                    style="cursor: pointer"
                    class="flex flex-col justify-between w-full mb-0 h-full"
                    v-for="item in selectItem.specialistcv"
                    :key="item.uid"
                >
                    <!-- Автарка ФИО -->
                    <div class="flex flex-col items-center">
                        <vs-avatar
                            size="80px"
                            onerror
                            :src="item.user_profile.avatar"
                        />
                        <h4
                            class="mt-4 truncate w-full"
                            style="color: #545da7; text-align: center"
                        >
                            {{
                                item.user_profile.fullname
                            }}
                            {{
                                item.user_profile["last_name_" + $i18n.locale] === null ||
                                item.user_profile["last_name_" + $i18n.locale] === "" ?
                                 item.user_profile["last_name_ru"] :
                                  item.user_profile["last_name_" + $i18n.locale]
                            }}
                            {{
                                item.user_profile["first_name_" + $i18n.locale] === null ||
                                item.user_profile["first_name_" + $i18n.locale] === "" ?
                                 item.user_profile["first_name_ru"] :
                                  item.user_profile["first_name_" + $i18n.locale]
                            }}
                            {{
                                item.user_profile["middle_name_" + $i18n.locale] === null ||
                                item.user_profile["middle_name_" + $i18n.locale] === "" ?
                                 item.user_profile["middle_name_ru"] :
                                  item.user_profile["middle_name_" + $i18n.locale]
                            }}

                        </h4>
                        <!-- Подзаголовок -->
                        <span style="max-width: 100%" class="mt-2 mb-2 text-wrap text-base truncate title_pod">{{
                            item["subtitle_" + $i18n.locale]
                        }}</span>
                        <!-- Кнопка записаться и подробнее -->
                        <div class="mt-2 flex-col">
                            <vs-button @click="view(item.uid, selectItem.uid)" class="w-full">{{
                                $t("more")
                            }}</vs-button>

                            <vs-button
                                @click="openModal(item.uid, selectItem.uid)"
                                class="w-full mt-2"
                                type="border"
                                >{{ $t("make_appointment") }}</vs-button
                            >
                        </div>
                    </div>
                </vs-card>
            </div>
        </div>
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import ModalWrite from "./ModalWrite";
export default {
    components: {
        ModalWrite,
    },

    data() {
        return {
            list: [],
            step: 1,
            selectItem: [],
        };
    },
    computed: {
        wMobile() {
            return window.innerWidth < 800;
        },
    },
    async created() {
        this.$vs.loading();
        const res = await this.$http("specialists/specialists-list/");
        if (res.status === 200) {
            this.list = res.data;
        }

        if(this.$route.query.specialId) {
            let i = this.list.find(item => item.uid === this.$route.query.specialId)
            this.selectSpec(i)
        }

        this.$vs.loading.close();
    },
    methods: {
        openModal(id, specialId) {
            this.$router.push({
                name: "cabinet-specialist-view",
                params: { openM: true },
                query: { uid: id, specialId: specialId },
            });
        },
        view(id, specialId) {
            this.$router.push({
                name: "cabinet-specialist-view",
                query: { uid: id, specialId: specialId },
            });
        },

        selectSpec(item) {
            this.selectItem = this.list.filter((el) => el.uid === item.uid)[0];
            this.step = 2;
        },
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}
.title_pod{
    min-height: 21px;
}
</style>
